import {useDataSource} from "src/core/data-sources/decorators/withData";
import ProductFiltersDataSource from "src/core/products/data-sources/filtersDataSource";
import useDeliveryType from "src/core/deliveries/hooks/useDeliveryType";
import {DeliveryTypes} from "src/core/common/models/DeliveryType";

function useProductFilterOptions(props) {
  const [deliveryType] = useDeliveryType();

  const {data: catalog, meta} = useDataSource(props, {
    dataSource: dataSource,
    requestCondition: deliveryType && deliveryType.code !== DeliveryTypes.UNAVAILABLE,
  });

  return [catalog, meta];
}

const dataSource = new ProductFiltersDataSource();

export default useProductFilterOptions;
